import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { signGdprApi, logoutApi } from "api/auth";
import { useUserStore } from "store/user";
import { gdprContentNo, gdprContentEn, GdprSection } from "content/gdprContent";
import "./GdprModal.css";

const renderSection = (section: GdprSection, index: number) => (
    <div key={index}>
        <h3>{section.heading}</h3>
        {section.paragraphs.map((p, i) => {
            if (typeof p === "string") {
                return <p key={i}>{p}</p>;
            }
            return (
                <ul key={i}>
                    {p.items.map((item, j) =>
                        typeof item === "string" ? (
                            <li key={j}>{item}</li>
                        ) : (
                            <li key={j}>
                                <a href={item.href} target="_blank" rel="noreferrer">{item.text}</a>
                            </li>
                        )
                    )}
                </ul>
            );
        })}
    </div>
);

const GdprModal = () => {
    const [loading, setLoading] = useState(false);
    const { setGdprSigned, resetStore } = useUserStore();
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();

    const content = gdprContentNo;

    const handleAccept = async () => {
        setLoading(true);
        try {
            await signGdprApi();
            setGdprSigned();
        } catch {
            // handle error if needed
        } finally {
            setLoading(false);
        }
    };

    const handleCancel = async () => {
        try {
            await logoutApi();
        } finally {
            resetStore();
            navigate("/login");
        }
    };

    return (
        <div className="gdpr-modal-overlay">
            <div className="gdpr-modal">
                <h2>{t("GdprTitle")}</h2>
                <div className="gdpr-modal-content">
                    {content.map(renderSection)}
                </div>
                <div className="gdpr-modal-actions">
                    <button className="gdpr-btn-accept" onClick={handleAccept} disabled={loading}>
                        {loading ? t("GdprSaving") : t("GdprAccept")}
                    </button>
                    <button className="gdpr-btn-cancel" onClick={handleCancel} disabled={loading}>
                        {t("Cancel")}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default GdprModal;